import { createAction, props } from '@ngrx/store';
import { Formulario } from '../../types/formulario.types';
import { PortalMode } from './projects.reducer';
import { MapLayer } from './projects.types';

export const setProjectsLayers = createAction(
  '[APP] Set Projects Layers',
  props<{ layers: MapLayer[] }>()
);

export const setCity = createAction(
  '[APP] Set City',
  props<{ city: string }>()
);

export const setConfiguracao = createAction(
  '[APP] Set Configuracao',
  props<{ configuracao: any }>()
);

export const updateMapLayerGeoJSONStr = createAction(
  '[APP] Update map layer GeoJSONStr',
  props<{ layerID: number; geoJSONStr: string }>()
);

export const getProjectsIds = createAction('[APP] Get Projects Ids');
export const getProjectsIdsSuccess = createAction(
  '[APP] Get Projects Ids Success',
  props<{
    ids: {
      pvgeoId: number | null;
      pvgeoGeomsQty: number | null;
      ouvCollabId: number | null;
      icadId: number | null;
      icadGeomsQty: number | null;
      zoneId: number | null;
      icadAPIAddr: string | null;
    };
  }>()
);
export const getProjectsIdsFail = createAction(
  '[APP] Get Projects Ids Fail',
  props<{ error: any }>()
);

export const clearOuvProjectsIds = createAction('[APP] Clear Ouv Projects Ids');
export const clearICADProjectId = createAction('[APP] Clear ICAD Project Id');

export const getProjectExtent = createAction('[APP] Get Project Extent');
export const getProjectExtentSuccess = createAction(
  '[APP] Get Project Extent Success',
  props<{ extent: any }>()
);
export const getProjectExtentFail = createAction(
  '[APP] Get Project Extent Fail',
  props<{ error: any }>()
);

export const getProjectLegend = createAction('[APP] Get Project Legend');
export const getProjectLegendSuccess = createAction(
  '[APP] Get Project Legend Success',
  props<{ legend: any }>()
);
export const getProjectLegendFail = createAction(
  '[APP] Get Project Legend Fail',
  props<{ error: any }>()
);

export const getLayerForms = createAction(
  '[APP] Get layer forms',
  props<{ layerName: string }>()
);

export const getLayerFormsSuccess = createAction(
  '[APP] Get layer forms success',
  props<{ layerName: string; layerForms: Formulario[] }>()
);

export const getLayerFormsFail = createAction(
  '[APP] Get layer forms fail',
  props<{ layerName: string; error: any }>()
);

export const getVM2CoreMedian = createAction('[APP] Get VM2 Core Median');
export const getVM2CoreMedianSuccess = createAction(
  '[APP] Get VM2 Core Median Success',
  props<{ vm2CoreMedian: number }>()
);
export const getVM2CoreMedianFail = createAction(
  '[APP] Get VM2 Core Median Fail'
);

export const setPortalMode = createAction(
  '[APP] Set Portal Mode',
  props<{ mode: PortalMode }>()
);

export const setHasBothPortalModes = createAction(
  '[APP] Set Has Both Portal Modes',
  props<{ hasBothPortalModes: boolean }>()
);
export const setIsICADDefault = createAction(
  '[APP] Set ICAD Default',
  props<{ icadDefault: boolean }>()
);
